import UserContext from '@context/UserContext';
import RegionForm from '@forms/Region';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';

type RegionDialogArgs = {
  resolve: (values?: guesthouse.Region) => void;
  reject: (e?: Error | boolean) => void;
  userContext: UserContext;
  title?: string;
  saveText?: string;
  cancelText?: string;
  initialValues?: object;
}


export const RegionDialog : React.FC<RegionDialogArgs> = (args) => {
  const { 
    resolve, 
    reject, 
    userContext, 
    title = 'Add Region',
    initialValues,
    saveText = 'Save',
    cancelText = 'Cancel',
  } = args;

  const [open, setOpen] = useState(true);

  return (
    <UserContext.Provider value={userContext}>
      <Dialog
        fullWidth
        open={open}
        maxWidth="sm"
        onClose={() => {
          resolve();
          setOpen(false);
        }}
      >
        <DialogTitle>
          {title}
        </DialogTitle>
        <DialogContent>
          <RegionForm
            error={false}
            submitText={saveText}
            initialValues={initialValues}
            onSubmit={(region) => {
              setOpen(false);
              resolve(region);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            onClick={() => {
              reject();
              setOpen(false);
            }}
          >
            {cancelText}
          </Button>
        </DialogActions>
      </Dialog>
    </UserContext.Provider>
  );
};
